import styled from 'styled-components';

import { gridSizes } from 'utils/style';

import Actions from 'components/RecurringOrderSuggestionsModal/Sections/Actions/component';

export default styled(Actions)`
  & {
    margin: ${gridSizes('M')} 0;
  }

  button:last-of-type {
    margin-top: ${gridSizes('M')};
  }
`;
